var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[(_vm.isAuth())?[(_vm.isLandlord())?_c('div',[_c('LandlordDashboard')],1):(_vm.isTenant())?_c('div',[_c('TenantDashboard')],1):(_vm.isUser())?_c('div',[_c('EndUserDashboard')],1):_c('div',[_c('NoRoleUserDashboard')],1)]:_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6b1516e2","hasScoped":true,"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/Dashboard.vue
// module id = 1482
// module chunks = 65